export const nuvemEnvioLabelsAppLinkPrefixes = [
  'nuvem-envio-app-back',
  'services-ne-app-back',
];

export const nuvemEnvioCarriers = ['Nuvem Envio', 'Envío Nube'];
